import React from 'react';
import Sidebar from './Sidebar';
import PosLicenseBanner from '../PosLicenseBanner';

export default function Layout({ children }) {
  return (
    <div style={{ display: 'flex', height: '100vh', overflow: 'hidden', background: '#f6f7fb' }}>
      <Sidebar />
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', height: '100vh', minWidth: 0 }}>
        {/* Renders only on an installed till whose fiscalization licence is not valid. */}
        <PosLicenseBanner />
        <main style={{ flex: 1, overflowY: 'auto', padding: '24px' }}>
          {children}
        </main>
      </div>
    </div>
  );
}
